import React from 'react'
import Text from './Text'

export default function Row (props) {
  const textClass = 'data-table__row-text'

  return (
    <div className={'data-table__row ' + props.rowColor}>
      <Text text={props.rowLeft} cls={textClass} />
      <Text text={props.rowRight} cls={textClass} />
    </div>
  )
}
